import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { InterfaceUtilization } from '../paf-result-utilization-icon/paf-result-utilization-icon.custom';
import { InterfaceUtilizationItem } from '../paf-result-utilization/paf-result-utilization.custom';

@Component({
  shadow: true,
  styleUrl: 'paf-result-row-footer.scss',
  tag: 'paf-result-row-footer',
})

export class PafResultRowFooter implements ComponentInterface {

  /** Platform on the departing location */
  @Prop() public platform?: string;

  /** Define the occupancy of first class */
  @Prop() public occupancyClassOne?: InterfaceUtilization['property'];

  /** Define the occupancy of second class */
  @Prop() public occupancyClassTwo?: InterfaceUtilization['property'];

  /** The duration of the trip */
  @Prop() public duration?: string;

  /**
   * CUS / HIM icons. Stringified array of icon names.
   * See InterfacePafIcon['cusHim'] for icon names.
   **/
  @Prop() public cusHimIcons?: string;

  /** Attribute icons. Stringified array of icon names. */
  @Prop() public attributeIcons?: string;

  /** If true, the platform will be highlighted */
  @Prop() public hasPlatformChange?: boolean;

  /**
   * If set to true, the component will show a loading skeleton
   */
  @Prop() public loading?: boolean;

  private _getOccupancyData = (): InterfaceUtilizationItem => ({
    utilizationItems: [
      {
        travelClass: '1',
        utilization: this.occupancyClassOne,
      },
      {
        travelClass: '2',
        utilization: this.occupancyClassTwo,
      },
    ],
  });

  public render(): HTMLDivElement {
    const hasAttributeIcons = JSON.parse(this.attributeIcons).length !== 0;

    return (
      <div class={{
        'loading': this.loading,
        'result-row-footer': true,
      }}>
        {this.loading &&
          <div class='loader'></div>
        }

        {/* Platform */}
        {this.platform &&
          <span
            class={{
              'platform': true,
              'platform-changed': this.hasPlatformChange,
            }}
            data-testid='platform'
          >{this.platform}</span>
        }

        {/* Occupancy */}
        {(this.occupancyClassOne && this.occupancyClassTwo) &&
          <paf-result-utilization
            level='1'
            config={JSON.stringify(this._getOccupancyData())}
            class='occupancy'
            data-testid='occupancy'
          />
        }

        {/* Attributes Icons */}
        {hasAttributeIcons &&
          <paf-result-attributes
            class='attribute-icons'
            config={this.attributeIcons}
            data-testid='attribute-icons'
            level='1'
          />
        }

        {/* CUS / HIM Icons */}

        <span
          class='cus-him-icons'
          data-testid='him-icons'
        >
          {this.cusHimIcons &&
            <span>
              {JSON.parse(this.cusHimIcons)
                .map((icon) => (
                  <paf-icon
                    variant='cus-him-l1'
                    name={icon}
                  />
                ))
              }
            </span>
          }
        </span>

        {/* Duration */}
        {this.duration &&
          <span class='duration'>{this.duration}</span>
        }
      </div>
    );
  }
}
